import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Loginbotton from '../Landingpagecomponents/Header/loginbotton';
import logo7 from '../Landingpagecomponents/images/logo7.png';
import background from '../Landingpagecomponents/images/pexels-gustavo-fring-4148956.jpg';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    color: '#002D55',
    background: `linear-gradient(90deg, rgba(220, 228, 235, 0.95), rgba(245, 242, 237, 0.84)), url(${background}) center/cover`,
  },
  header: {
    height: 76,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 clamp(20px, 5vw, 72px)',
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    borderBottom: '1px solid rgba(0, 45, 85, 0.12)',
  },
  logo: {
    width: 'auto',
    height: 48,
    maxWidth: 'min(180px, 42vw)',
    objectFit: 'contain',
  },
  betaLabel: {
    color: '#3d5a80',
    fontWeight: 700,
    fontSize: '0.75rem',
    letterSpacing: 1.2,
  },
  main: {
    flex: 1,
    display: 'grid',
    placeItems: 'center',
    padding: '48px 20px 72px',
  },
  content: {
    width: 'min(660px, 100%)',
    textAlign: 'center',
  },
  lock: {
    width: 58,
    height: 58,
    display: 'grid',
    placeItems: 'center',
    margin: '0 auto 26px',
    borderRadius: '50%',
    color: '#fff',
    background: '#fb741a',
    boxShadow: '0 14px 30px rgba(251, 116, 26, 0.28)',
  },
  title: {
    fontWeight: 700,
    fontSize: 'clamp(2rem, 5vw, 3.75rem)',
    lineHeight: 1.08,
    marginBottom: 18,
  },
  body: {
    color: '#3d5a80',
    fontSize: '1.08rem',
    lineHeight: 1.7,
    maxWidth: 540,
    margin: '0 auto 30px',
  },
  button: {
    backgroundColor: '#002D55',
    color: '#fff',
    padding: '13px 25px',
    borderRadius: 18,
    fontWeight: 700,
    textTransform: 'none',
    boxShadow: '0 12px 26px rgba(0, 45, 85, 0.22)',
    '&:hover': { backgroundColor: '#0a416f' },
  },
  note: {
    marginTop: 22,
    color: '#617891',
    fontSize: '0.88rem',
  },
  [theme.breakpoints.down('xs')]: {
    header: { height: 64 },
    main: { paddingTop: 36 },
  },
}));

export default function PrivateProjectLandingPage() {
  const classes = useStyles();
  const [loginOpen, setLoginOpen] = React.useState(false);

  return (
    <Box className={classes.page}>
      <header className={classes.header}>
        <img className={classes.logo} src={logo7} alt="Virtus Physio" />
        <Typography className={classes.betaLabel}>PRIVATE PROJECT</Typography>
      </header>
      <main className={classes.main}>
        <section className={classes.content} aria-labelledby="beta-title">
          <div className={classes.lock}><LockOutlinedIcon /></div>
          <Typography component="h1" id="beta-title" className={classes.title}>
            Virtus One
          </Typography>
          <Typography className={classes.body}>
            Private access. Sign in below.
          </Typography>
          <Button className={classes.button} variant="contained" onClick={() => setLoginOpen(true)}>
            Sign in
          </Button>
          <Typography className={classes.note}>
            This is a private project shared only with a few trusted people for early feedback.
          </Typography>
          <Typography className={classes.note}>
            It is not a product, service, or business.
          </Typography>
        </section>
      </main>
      <Loginbotton open={loginOpen} onOpenChange={setLoginOpen} showTrigger={false} />
    </Box>
  );
}